import React, { useMemo } from 'react'
import { makeStyles, Icon } from '@material-ui/core'
import { successes, warnings } from '../../../utils/colors'
import { FONT_WEIGHTS } from '../../../utils'

const WizardAlert = ({ type = 'success', text = '' }) => {
	const classes = useStyles({ type })()

	const icon = useMemo(() => {
		if (type === 'success') {
			return (
				<Icon
					className="fas fa-check-circle"
					style={{
						fontSize: '0.8rem',
						fontWeight: '400',
						color: successes[500],
						overflow: 'unset'
					}}
				/>
			)
		}
		if (type === 'warning') {
			return (
				<Icon
					className="fas fa-exclamation-circle"
					style={{ fontSize: '0.8rem', fontWeight: '400', color: warnings[500], overflow: 'unset' }}
				/>
			)
		}
		return null
	}, [type])

	return (
		<div className={classes.root}>
			<div className={classes.iconContainer}>{icon}</div>
			<div className={classes.textContainer}>{text}</div>
		</div>
	)
}

const useStyles = ({ type }) =>
	makeStyles(() => ({
		root: {
			backgroundColor: type === 'success' ? successes[10] : 'warning' ? warnings[10] : gray[100],
			padding: '.5rem .8rem',
			borderRadius: '.375rem',
			display: 'flex',
			gap: '.8rem'
		},
		iconContainer: {
			display: 'flex',
			alignItems: 'center'
		},
		textContainer: {
			flex: 1,
			fontFamily: 'Nunito',
			fontSize: '0.875rem',
			display: 'flex',
			alignItems: 'center',
			fontWeight: FONT_WEIGHTS.Regular,
			color: type === 'success' ? successes[500] : 'warning' ? warnings[500] : gray[500]
		}
	}))

export default WizardAlert
